var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEdit = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.96867 13.9157L13.6592 4.41662C14.906 3.19446 16.9283 3.19446 18.175 4.41662L19.4694 5.6854C20.7162 6.90755 20.7162 8.88984 19.4694 10.112L9.74061 19.6486C9.1843 20.1939 8.43007 20.4999 7.64282 20.4999H3.65854C3.28841 20.4999 2.99098 20.201 3.00021 19.8383L3.10043 15.8975C3.12036 15.1526 3.43127 14.4425 3.96867 13.9157ZM18.538 6.59833L17.2437 5.32955C16.5112 4.61158 15.3229 4.61158 14.5905 5.32955L13.8382 6.067L17.7861 9.93615L18.538 9.19911C19.2705 8.48114 19.2705 7.31629 18.538 6.59833ZM4.89993 14.8287L12.9069 6.97991L16.8548 10.8491L8.80925 18.7357L8.70223 18.8318C8.40665 19.0745 8.03217 19.2089 7.64277 19.2089L4.3334 19.2084L4.41702 15.9305C4.42809 15.5169 4.60121 15.1215 4.89993 14.8287ZM21 19.8545C21 19.498 20.7051 19.2089 20.3414 19.2089H13.471L13.3816 19.2148C13.0602 19.2576 12.8124 19.5277 12.8124 19.8545C12.8124 20.211 13.1073 20.5 13.471 20.5H20.3414L20.4308 20.4941C20.7522 20.4514 21 20.1813 21 19.8545Z",
  fill: "#1A21BA"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit.400e4363.svg";
export { ForwardRef as ReactComponent };